import { ValidationMode, useForm, type UseFormReturn } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { translate } from 'translations/i18n';
import { type CreatePublicProfileParams } from 'data/v3/publicProfiles/types';

export type UseProfileFormReturn = UseFormReturn<CreatePublicProfileParams>;

const ProfileSchema = Yup.object().shape(
  {
    name: Yup.string().required(
      translate('portfolio.profile.validation.companyName'),
    ),
    phoneNumber: Yup.string().when('email', {
      is: (email: string) => !email,
      then: Yup.string()
        .trim()
        .required(translate('portfolio.profile.validation.phoneOrEmail'))
        .min(9, translate('portfolio.profile.validation.invalidPhone'))
        .max(15, translate('portfolio.profile.validation.invalidPhone')),
      otherwise: Yup.string().nullable(),
    }),
    email: Yup.string().when('phoneNumber', {
      is: (phone: string) => !phone,
      then: Yup.string()
        .required(translate('portfolio.profile.validation.phoneOrEmail'))
        .email(translate('portfolio.profile.validation.invalidEmail')),
      otherwise: Yup.string()
        .nullable()
        .email(translate('portfolio.profile.validation.invalidEmail')),
    }),
    industries: Yup.array()
      .of(Yup.string().required())
      .min(1, translate('portfolio.profile.validation.industries')),
    serviceAreas: Yup.array()
      .of(Yup.string().required())
      .min(1, translate('portfolio.profile.validation.serviceAreas')),
  },
  [['email', 'phoneNumber']],
);

export const useProfileForm = ({
  mode = 'onBlur',
}: {
  mode?: keyof ValidationMode;
} = {}) => {
  return useForm<CreatePublicProfileParams>({
    resolver: yupResolver(ProfileSchema),
    defaultValues: {
      industries: [],
      serviceAreas: [],
    },
    mode,
  });
};
